module.exports = __webpack_public_path__ + "static/media/Subtract-4.bf99df48.svg";